import React from 'react';
import HeaderSection from './Header';
import Footer from '../components/Footer';
import rowdata from './rowdata';
import PageHeading from '../components/PageHeading';
const data = [
  { pic: "./public/images/c1.png"},
  { pic: "./public/images/c3.png"},
  { pic: "./public/images/c6.png"},
  { pic: "./public/images/c8.png"},
  { pic: "./public/images/c5.png"},
  { pic: "./public/images/c9.png"},
  { pic: "./public/images/c2.png"},
  { pic: "./public/images/c7.png"},
];
const Card = ({pic}) => (
  <section className="clients-card column align-middle small-6 large-3">
    <article className="card-wrapper clients-card__wrapper">
      <figure>
        <img src={pic} className="clients-card__images"/>
      </figure>
    </article>
  </section>
)
const RowCard = ({title, pic, items}) => (
  <section className="clients-row-card column large-4 medium-expanded small-12">
    <article className="clients-row-card__wrapper">
      <figure>
        <img src={pic} className="clients-row-card__image" />
      </figure>
      <header className="row">
        <h3 className="text-center">{title}</h3>
      </header>
      <section className="text-justify clients-row-card__content">
        {items.map((item, index) => <span key={index}>{item}</span>)}
      </section>
    </article>
  </section>
);
const ClientsPage = (props) => {
  return(
    <main className="clients-page">
      <HeaderSection />
      <section>
        <article className="section-clients-background">
          <PageHeading
            text1='Our '
            text2='Clients '
            text3=''
          />
        </article>
        <article className="row align-spaced">
          {data.map((item, index) =>
            <Card key={index} {...item} />
          )}
        </article>
        <article className="section-review__background-color">
          <header>
            <h2 className="text-center">Reviews</h2>
          </header>
          <section className="row align-spaced section__content">
            {rowdata.map((item, index) =>
             <RowCard key={index} {...item} />
            )}
          </section>
        </article>
      </section>
      <Footer />
    </main>
  );
};
export default ClientsPage;



// WEBPACK FOOTER //
// ./src/ClientsPage/index.js